import React, { useState } from 'react';
import '../../styles/Page.css';
import '../../styles/Hero.css';

import { useApi } from '../../hooks/useApi';
import { useAuth } from '../../contexts/AuthContext';
import useLocalStorage from '../../hooks/useLocalStorage';
import PostTimerHero from './PostTimerHero';
import HowTo from './HowTo';
import ResultsList from './ResultsList';
import LegalNote from '../../components/LegalNote';

function PostTimer() {
    const [subreddit, setSubreddit] = useLocalStorage('postTimer_subreddit', '');
    const { loading, error, request: timerApi } = useApi();
    const { fetchQuota } = useAuth();
    const [result, setResult] = useState(null);
    const [heatmapData, setHeatmapData] = useState(null);
    const [timezone, setTimezone] = useState('');


    const handleFocus = (event) => event.target.select();

    const getSubredditName = (input) => {
        const trimmedInput = input.trim();
        const match = trimmedInput.match(/reddit\.com\/r\/([^/]+)/);
        if (match) return match[1];
        if (trimmedInput.startsWith('r/')) return trimmedInput.substring(2);
        return trimmedInput;
    };

    const handleAnalyze = async (e) => {
        e.preventDefault();
        setResult(null);
        setHeatmapData(null);
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setTimezone(tz);

        const subredditName = getSubredditName(subreddit);

        try {
            const data = await timerApi(`/api/best_posting_times?subreddit=${encodeURIComponent(subredditName)}&timezone=${encodeURIComponent(tz)}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });
            setResult(data);
            setHeatmapData(data.raw_heatmap);
            fetchQuota();
        } catch (err) {
            console.error("Analysis failed:", err);
            // If an error occurs, set result to an empty object and heatmapData to an empty object
            // If an error occurs, set result to an empty object and heatmapData to an empty object
            // to ensure ResultsList is rendered with empty data, as per user request.
            setResult({});
            setHeatmapData({});
        }
    };

    return (
        <>
            <title>Post Timer - WizeHelper</title>
            <meta name="description" content="Analyze any subreddit to discover the optimal times to post for maximum visibility and engagement." />


            <main className="mx-auto px-6 py-8" style={{ maxWidth: '88rem' }}>
                <PostTimerHero
                    subreddit={subreddit}
                    setSubreddit={setSubreddit}
                    handleAnalyze={handleAnalyze}
                    loading={loading}
                    handleFocus={handleFocus}
                />
                <LegalNote />
                {error && (
                    <div className="p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg" role="alert" data-testid="postTimer-error">
                        {error.status === 403 || error.status === 429 ? (
                            error.message
                        ) : (
                            <><span className="font-medium">Error!</span> {error.message}</>
                        )}
                    </div>
                )}
                {loading ? (
                    <div className="text-center my-12" data-testid="postTimer-loading">
                        <div className="spinner"></div>
                    </div>
                ) : (
                    <>
                        {result ? (
                            <ResultsList
                                result={result}
                                heatmapData={heatmapData}
                                timezone={timezone}
                            />
                        ) : (
                            <div className="my-12" data-testid="postTimer-howToContainer">
                                <HowTo />
                            </div>
                        )}
                    </>
                )}
            </main>
        </>
    );
}

export default PostTimer;
